export const JSX = {
    createElement(name: string|Function, props: { [id: string]: any }, ...content: any[]) {
        props = props || {};
        if(!name) return content;
        if(typeof name === 'function'){
            if(!(name.prototype instanceof JSXElement)) {
                if(!name.prototype?.['render'])
                    return name(props, content);
                console.warn(`Element ${name} is function, but not instance of JSXElement!`);
            }
            const el = new (name as any)(props, content) as JSXElement<any>;
            return (el.element=el.render() as HTMLElement);
        }
        const propsstr = Object.keys(props)
            .map(key => {
                let value = props[key];
                if (key === "className") {
                    key='class';
                    if(Array.isArray(value)) value = value.join(' ');
                }
                if(key === 'style'){
                    if(typeof value === 'object')
                        value = Object.entries(value).map(([k, v]) => `${
                            k.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`)
                        }:${v}`).join(';')
                }
                // value = JSON.stringify(escapeHtml(value+""));
                return [key,value];
            })

            // .join(" ");
        const element = document.createElement(name);
        for(const [k, v] of propsstr){
            if(v === undefined) continue;
            if(!k) return;
            if(k === 'ref'){
                v.value = element;
            }
            else if(k.startsWith('once') && k[4].toLowerCase() !== k[4]){
                const eventName = k.substring(4).toLowerCase();
                element.addEventListener(eventName, v, {once: true});
            }
            else if(k.startsWith('on') && k[2].toLowerCase() !== k[2] ){
                const eventName = k.substring(2).toLowerCase();
                element.addEventListener(eventName, v);
            }
            else {
                element.setAttribute(k, v)
            }
        }
        function workWithOneContent(content: any){
            if(content instanceof NodeList) content = Array.from(content);
            if(Array.isArray(content) ) {
                content = content.map(e=>Array.isArray(e) && e.length === 1? e[0]:e);
                for(let i=0;i<content.length;i++){
                    const item = content[i];
                    if(item === false || item === undefined) continue;
                    if(i < content.length-1){
                        if(typeof item === 'string' && typeof content[i+1] === 'string') {
                            content[i + 1] = item + content[i + 1];
                            continue;
                        }
                    }
                    workWithOneContent(item);

                }
            }
            else {
                if (!(content instanceof Node)) content = document.createTextNode(content);
                element.appendChild(content)
            }
        }
        workWithOneContent(content);
        return element;
        // if(['img', 'area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr'].includes(name))
        //     return `<${name}${propsstr?' '+propsstr:''}>`;
        // return `<${name}${propsstr?' '+propsstr:''}>${contentStr}</${name}>`;
    },
    Fragment: ''
};

export abstract class JSXElement<Props>{
    public element!: HTMLElement;
    constructor(protected readonly props: Props, protected readonly content: any[]){}
    abstract render(): Node;
}
export default JSX;